import React, { useContext, useEffect, useState } from 'react';
import { Breadcrumb } from "react-bootstrap";
import { withTranslation } from 'react-i18next';
import { BiPlus } from "react-icons/bi";
import { RegulationContext } from '../../../App';
import { USER_ROLE } from '../../../core/constants/common';
import StandardService from '../../../core/service/StandardService';
import NoStandards from './NoStandards';
import './Standards.scss';
import StandardsAdminMain from './StandardsAdminMain/StandardsAdminMain';
import StandardsCreate from './StandardsCreate/StandardsCreate';
import StandardsMain from './StandardsMain/StandardsMain';

function Standards({ t, forSuperAdmin = false }) {
  const { glbRegulation, setGlbRegulation } = useContext(RegulationContext);
  const [list, setList] = useState([]);
  const [openStandardSave, setOpenStandardSave] = useState(false);
  const [parent, setParent] = useState(0);
  const [type, setType] = useState("STANDARD");
  const [isChildDat, setIsChildDat] = useState(false);
  const [currentid, setCurrentId] = useState(null);
  let data = JSON.parse(localStorage.getItem("authority"));
  useEffect(() => {
    getStandards();
  }, [glbRegulation]);
  const handleCreateCallback = (obj) => {
    setOpenStandardSave(false);
    getStandards();
  };
  const handleShow = () => {
    setOpenStandardSave(true);
  };
  const getStandards = () => {
    StandardService.getStandards('S', data.roles.includes(USER_ROLE.SUPER_ADMIN))
      .then((response) => {
        let filter = [];
        if (window.location.pathname == '/admin/standard' || window.location.pathname === '/admin/std_config') {
          filter = response.data;
        } else {
          filter = response.data.filter(x => x.id == glbRegulation.id);
        }
        setList([...filter]);
      })
      .catch((error) => {
      });
  };
  const handleChildToggleContent = (data) => {
    if (data.childStatus === "Expand") {
      setType(data.type);
    } else if (data.childStatus === "Close") {
      data.parent === 0 && getStandards();
    }
  };

  const setChild = (isChild, id) => {
    setIsChildDat(isChild);
    setCurrentId(id);
  }

  const renderConfigList = () => {
    if (list.length === 0) return <NoStandards/>;

    if (data.roles.includes(USER_ROLE.SUPER_ADMIN)) {
      return (
        list?.map((item) => (
          <>{
            <div>
              <StandardsAdminMain
                key={item.id}
                listObj={item}
                handleChildToggle={handleChildToggleContent}
                parent={parent}
                sType={type}
                setChild={setChild}
                forSuperAdmin={forSuperAdmin}
              />
            </div>
          }</>
        ))
      );
    } else {
      return (
        list?.map((item) => (
          <>{<StandardsMain
            key={item.id}
            listObj={item}
            handleChildToggle={handleChildToggleContent}
            parent={parent}
            sType={type}
            setChild={setChild}
          />}</>
        ))
      );
    }
  };

  return (
    <>
      <div className="Standards">
        <div className="List_header pb-2">
          <Breadcrumb className="h5 m-0">
            <Breadcrumb.Item href="#">{t("Configurations.label")}</Breadcrumb.Item>
            <Breadcrumb.Item active>{t("dataPoints.label")}</Breadcrumb.Item>
          </Breadcrumb>

          {data.roles.includes("SUPER_ADMIN") && (
            <div className="py-1 text-end">
              <button className="btn btn-primary" onClick={handleShow}>
                <BiPlus className='me-2' />
                {t("New.label")}
              </button>
            </div>
          )}
        </div>

      </div>
      {openStandardSave && <StandardsCreate handleCreateCallback={handleCreateCallback} />}
      {list?.length >0 &&  renderConfigList()}
    </>
  );
}


export default withTranslation()(Standards);
